import React, { Component } from "react";
import { Link as ScrollLink, Events, Element, animateScroll as scroll } from "react-scroll";
import _ from 'lodash';
import "./Work.css";
import { Link, withRouter } from "react-router-dom";
import { Grid, Row, Col, Carousel } from "react-bootstrap";
import Footer from "./Footer";
import { observer } from "mobx-react";
import config from "../config";
import appStoreUrl from "../assets/images/appstore.png"
import playUrl from "../assets/images/google.png"

@withRouter
@observer
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsOpen: false,
      goToTopBoxAnim: false,
      whiteLogo: true,
      carouselIndex: 0,
      carouselDir: null
    };
  }
  componentWillMount() {
    window.CURRENT_SLIDE = this.props.workIndex;
  }
  componentDidMount() {
    const pathname = _.get(this.props, 'history.location.pathname', '');
    if(pathname && this.props.ga){
      this.props.ga.pageview(pathname);
    }

    let self = this;

    Events.scrollEvent.register("begin", function(scrollElement) {
      let detailOpen = null;

      if (scrollElement === "detailsStart") {
        detailOpen = true;
      } else if (scrollElement === "topElement") {
        detailOpen = false;
      }

      if (detailOpen !== null) {
        self.setState({
          detailOpen
        });
      }
    });
  }
  componentWillUnmount() {
    Events.scrollEvent.remove("begin");
  }
  scrollToTop = () => {
    scroll.scrollToTop({
      containerId: "containerElement"
    });
  };
  handleScroll = e => {
    let windowHeight = window.innerHeight;
    let elementOffsetTop = this._goToTopBox.getBoundingClientRect().top - windowHeight;
    let scrollTop = e.target.scrollTop;
    let detailsOpen = null;
    const { whiteLogo } = this.state;
    const { onChangeLogoToWhite } = this.props;

    if (elementOffsetTop <= 0 && !this.state.goToTopBoxAnim) {
      this.setState({
        goToTopBoxAnim: true
      });
    }

    if (scrollTop > windowHeight / 2 && whiteLogo) {
      this.setState({ whiteLogo: false });
      onChangeLogoToWhite(false);
    } else if (scrollTop < windowHeight / 2 && !whiteLogo) {
      this.setState({ whiteLogo: true });
      onChangeLogoToWhite(true);
    }

    if (!scrollTop) {
      detailsOpen = false;
    }

    if (!this.state.detailsOpen) {
      detailsOpen = true;
    }

    if (detailsOpen !== null) {
      this.setState({
        detailsOpen
      });
    }
  };
  handleSliderSelect = (carouselIndex, e) => {
    this.setState({
      carouselIndex,
      carouselDir: e.direction
    });
  };
  render() {
    const project = this.props.work;
    const { workIndex } = this.props;
    const workNumber = workIndex + 1;
    const { carouselIndex, carouselDir } = this.state;
    const {
      title,
      description,
      url,
      mainImage,
      gallery,
      developers,
      timeDays,
      timeHours,
      body,
      ios,
      android
    } = project;
    const carouselData = {
      index: carouselIndex + 1,
      count: project.gallery ? project.gallery.length : 0
    };

    return (
      <div className="Work" onScroll={this.handleScroll} ref="work" id="containerElement">
        <Element name="topElement" />
        <div className="background" style={{ backgroundImage: "url(" + mainImage + ")" }} />
        <div className="inner-content">
          <Link to={`/`} onClick={this.scrollToTop} className="title">
            <span className="title__index">{workNumber < 10 ? "0" + workNumber : workNumber}</span>
            {title}
          </Link>
          <div className="description-wrapper">
            <Grid>
              <a href={url} className="site_link" target="_blank">
                Visit the site
              </a>
              <Row className="show-grid" name="mainInfo">
                <Col xs={6} md={2}>
                  <div className="description-title"> Timeframe &amp; Efforts</div>
                  <div className="description-value">
                    <b>{`${timeHours} hours`}</b>
                  </div>
                  <div className="description-value">
                    <b>{`${timeDays} days`}</b>
                  </div>
                </Col>
                <Col xs={6} md={4}>
                  <div className="description-title"> Team</div>
                  {developers.map((dev, i) => (
                    <div className="description-value" key={i}>
                      {dev.role}:<b>{dev.name}</b>
                    </div>
                  ))}
                </Col>
                <Col xs={12} md={6}>
                  <div className="description-title"> About</div>
                  <div className="description-value">{description}</div>
                </Col>
              </Row>
              <div className="go-to-bottom">
                <ScrollLink
                  to="detailsStart"
                  containerId="containerElement"
                  spy={true}
                  smooth={true}
                  duration={500}
                  className="swiper-button-bottom"
                />
              </div>
              <div className={this.state.detailsOpen ? `work-content work-content_${config.type}` : `work-content__${config.type} invisible`}>
                <div className="work-content__text">
                  <div className="longcontent" dangerouslySetInnerHTML={{ __html: body }} />
                </div>
                <div className="work-content__slider" name="detailsStart">
                  <div className={`carousel-wrapper slider_${config.type}`}>
                    <Carousel
                      onSelect={this.handleSliderSelect}
                      activeIndex={carouselIndex}
                      direction={carouselDir}
                      indicators={false}
                    >
                      {gallery.map((image, i) => (
                        <Carousel.Item key={i}>
                          <img src={image} alt="" className="carousel-overlay" />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                    <span className="carousel-indicators-text">
                      {carouselData.index < 10 ? "0" + carouselData.index : carouselData.index}/
                      {carouselData.count < 10 ? "0" + carouselData.count : carouselData.count}
                    </span>
                  </div>
                  <div className="mobile-links">
                    {android &&
                    <a href={android} target="blank" className="mobile-button-wrapper">
                      <img src={playUrl}/>
                    </a>
                    }
                    {ios &&
                    <a href={ios} target="blank" className="mobile-button-wrapper">
                      <img src={appStoreUrl}/>
                    </a>
                    }
                  </div>
                </div>
              </div>
            </Grid>
            <div
              className="go-to-top"
              id="scrollPosition"
              ref={node => {
                this._goToTopBox = node;
              }}
            >
              <ScrollLink
                to="topElement"
                containerId="containerElement"
                spy={true}
                smooth={true}
                duration={500}
                className={
                  this.state.goToTopBoxAnim ? "swiper-button-top animation" : "swiper-button-top"
                }
              />
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Work.js